import * as types from "./subscriptionTypes";

export const toggleModal =
  ({ name, visible = true }) =>
  dispatch => {
    dispatch({ type: types.SUBSCRIPTION_TOGGLE_MODAL_SUCCESS, name, visible });
  };
